import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  FETCH_INVOICE_FAILURE,
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS
} from "../types";

const fetchInvoice = id => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(createAction(FETCH_INVOICE_REQUEST)());
    const response = await api.factoring.getInvoice(id);
    const data = normalize(
      { id: `${id}-invoice`, ...response },
      schema.factoring_document
    );
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_INVOICE_SUCCESS)({
        [id]: data.result
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_INVOICE_FAILURE)(err));
    throw err;
  }
};

export default fetchInvoice;
